import {
  AverageAssessmentAnswersByProgramFragment,
  CompetencyCriteriaNode,
  CompetencyGoalFragmentFragment,
  ProfileCareerTabCompetencyFragment,
  ProfileCareerTabRoleFragment,
} from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import { isAdminVar } from "@cache/cache";
import { currentUserVar } from "@cache/cache";

import CompetencyCriteria from "./competency-criteria";
import CompetencyGoals from "./competency-goals";
import NA from "./na";

const Competency = ({
  competency,
  profile,
  role,
  goals,
  criteria,
  averageAssessmentAnswers,
}: {
  profile: BasicUser & { isInCurrentUserReportingTree: boolean };
  competency: ProfileCareerTabCompetencyFragment;
  role?: ProfileCareerTabRoleFragment;
  goals: CompetencyGoalFragmentFragment[];
  criteria: Pick<CompetencyCriteriaNode, "id" | "content">[];
  averageAssessmentAnswers: AverageAssessmentAnswersByProgramFragment[];
}) => {
  const isAdmin = isAdminVar();
  const currentUser = currentUserVar();
  const canViewAverageAssessmentAnswers =
    profile.id === currentUser.id ||
    profile.isInCurrentUserReportingTree ||
    isAdmin;
  return (
    <>
      <div className="flex justify-between items-center gap-2 flex-wrap mb-2">
        <div className="font-semibold text-gray-700">{competency.title}</div>
        {role && canViewAverageAssessmentAnswers && (
          <CompetencyGoals
            roleId={role.id}
            roleTitle={role.title}
            goals={goals}
            competency={competency}
            profile={profile}
          />
        )}
      </div>
      {role ? (
        <CompetencyCriteria
          criteria={criteria}
          averageAssessmentAnswers={averageAssessmentAnswers}
          profile={profile}
        />
      ) : (
        <NA />
      )}
    </>
  );
};

export default Competency;
